import { useModalSlot } from 'vue-final-modal'
import ModalContentAgeCheck from '~/components/Modal/Content/ModalContentAgeCheck.vue'
import ModalContentAgeCheckBottom from '~/components/Modal/Content/ModalContentAgeCheckBottom.vue'
import { webshopSettings } from '~/store/webshopSettings'
import { isMenuPath } from '~/utils/path-utils'
let ageCheckWatcher: (() => void) | null = null

export async function showGlobalAgeCheckModal (routePath: string) {
    const localePath = useLocalePath()
    if (webshopSettings()?.global?.webshopAgePopup && (routePath === localePath('/') || isMenuPath(routePath))) {
        if (ageCheckWatcher !== null) {
            ageCheckWatcher()
        }
        const modalInstance = await messagesModal({
            default: useModalSlot({
                component: ModalContentAgeCheck
            }),
            bottom: useModalSlot({
                component: ModalContentAgeCheckBottom,
                attrs: {
                    closeModal: () => {
                        modalInstance.close()
                    }
                }
            })
        })
    } else if (ageCheckWatcher === null) {
        const route = useRoute()
        ageCheckWatcher = watch(() => route.fullPath, async newRoute => {
            await showGlobalAgeCheckModal(newRoute)
        })
    }
}
